<template>
    <div class="row">
        <div class="col-12 mb-3">
            <button class="button large-button btn-block effect-button" v-if="evento && evento.descuento_abonado && mode == 1" @click="mode = 2">Venta día del abonado</button>
            <button v-if="mode == 2" class="button large-button btn-block effect-button" @click="mode = 1">Venta normal</button>
        </div>
        <div class="col-12" v-if="evento && evento.descuento_abonado && mode == 2">
            <div class="row">
                <div class="col-12">
                    <BuscarAbonadoComponent :abonado="abonado_search" v-on:terminado="buscarAbonado"></BuscarAbonadoComponent>
                </div>
                <div v-if="buscando" class="col-12">
                    <LoaderComponent></LoaderComponent>
                </div>
                <div class="col-12" v-if="error">
                    <section class="padding-vertical-content">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="alert alert-danger" role="alert">
                                        <h4 v-if="error != 'comprado'">{{ error }}</h4>
                                        <p v-else>
                                            <b>¡Ya activaste tu abono!</b>
                                            <br>

                                            Te recordamos que un abono, únicamente puede disponer de una entrada por lo que no es posible adquirir más entradas con este número de abonad@ y este dni.
                                            <br>

                                            <b>Cualquier cuestión nos tienes en {{ manager.email_incidencias || 'info@compralaentrada.com' }}</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div class="col-12 mt-3" v-if="mostrar_opciones">
                    <div class="row">
                        <div class="col-6">
                            <button class="button large-button btn-block effect-button" v-if="asiento_disponible" @click="contiuarConMiAsiento(puede_cambiar)"><span>Continuar con mi asiento</span></button>
                            <button class="button large-button btn-block btn-danger" v-else disabled><small>El Asiento que corresponde a su abono ya está ocupado / o no hay precios disponibles para este asiento.</small></button>
                        </div>
                        <div class="col-6">
                            <button v-if="puede_cambiar" class="button large-button btn-block effect-button" @click="seleccionarNuevoAsiento"><span>Seleccionar un nuevo asiento</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12" v-if="!cargando && evento" id="mapa">
            <div class="col-12">
                <template v-if="evento.place_obj.svg_teatros">
                    <CleSvgComponent 
                        v-if="zonas_formated.length > 0"
                        :zonas="zonas_formated" 
                        :place="evento.place_obj" 
                        :sesion_id="sesion_id"
                        @clickZona="goTo"
                    ></CleSvgComponent>
                </template>
                <template v-else>
                    <MapaSvgComponent 
                        :zonas="zonas_formated" 
                        :can_click="true" 
                        :popup_enabled="true" 
                        :occupied="false"
                        @clickZona="goTo"
                        :place="evento.place_obj"
                    ></MapaSvgComponent>
                </template> 

                <h3 v-if="zonas">
                    <b>Libres: </b>
                    {{ total_libres }}
                </h3>
            </div>
            <div class="col-12">
                <TablaSectoresComponent :zonas="zonas" v-on:goTo="goTo"></TablaSectoresComponent>
            </div>
        </div>
        <div class="col-12" v-else>
            <LoaderComponent></LoaderComponent>
        </div>
    </div>
</template>

<script>
    import MapaSvgComponent from '@/components/backend/stepper/components/MapaSvgComponent';
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';
    import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent';
    import BuscarAbonadoComponent from '@/components/backend/stepper/components/BuscarAbonadoComponent';

    export default {
        props: ['evento', 'sesion_id'],
        data() {
            return {
                mode: 1,
                cargando: false,
                loading: false,
                continuar: false,
                zonas: null,
                abonado_search: {
                    dni: null,
                    n_abonado: null
                },
                buscando: false,
                error: null,
                asientos: [],
                datos_compradores: {},
                asiento_disponible: false,
                zona: null,
                mostrar_opciones: false,
                comprado: false,
                puede_cambiar: false
            }
        },
        created() {
            if(this.evento && this.evento.tiene_recinto) {
                this.getZonas();
            }            
        },
        watch: {
            mode() {
                
            }
        },
        computed: {
            total_libres() {
                var total = 0;

                if(this.zonas_formated && this.zonas_formated.length > 0) {
                    for (var i = 0; i < this.zonas_formated.length; i++) {
                        if(this.zonas_formated[i].name != 'Internacional' && this.zonas_formated[i].name != 'Baby' && this.zonas_formated[i].name != 'internacional' && this.zonas_formated[i].name != 'INTERNACIONAL' && this.zonas_formated[i].esta_disponible) {
                            var libres = this.zonas_formated[i].with_seats ? this.zonas_formated[i].total_asientos : this.zonas_formated[i].aforo;

                            libres = libres - this.zonas_formated[i].bloqueados - this.zonas_formated[i].confirmados - this.zonas_formated[i].no_confirmados - this.zonas_formated[i].sesion;

                            total = total + libres;
                        }
                    }
                }

                return total;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            zonas_formated() {
                var array = [];

                var zonas_f = Object.assign({}, this.zonas[zona]);

                if(this.mode == 1) {
                    for(var zona_n in this.zonas) {
                        array.push(Object.assign({}, this.zonas[zona_n]));
                        var disponible_n = array[zona_n].precios.length > 0 && array[zona_n].esta_disponible ? true : false;
                        array[zona_n].esta_disponible = disponible_n;
                    }
                } else {
                   for(var zona in this.zonas) {
                        array.push(Object.assign({}, this.zonas[zona]));
                        var precios_array = [];

                        for(var pa in array[zona].precios_abonados) {
                            precios_array.push({
                                'descripcion': array[zona].precios_abonados[pa].description,
                                'gd': array[zona].precios_abonados[pa].price_management_taquilla,
                                'gd_interno': array[zona].precios_abonados[pa].price_management_taquilla_interno,
                                'id': array[zona].precios_abonados[pa].id,
                                'precio': array[zona].precios_abonados[pa].price,
                                'precio_total': array[zona].precios_abonados[pa].price + array[zona].precios_abonados[pa].price_management_taquilla
                            })
                        }

                        array[zona].precios = precios_array;
                        var disponible = precios_array.length > 0 && array[zona].esta_disponible ? true : false;
                        array[zona].esta_disponible = disponible;
                    }
                }

                return array;
            }
        },
        methods: {
            goTo(paso, data) {

                var abonado = {};

                if(this.mode == 2) {
                    this.datos_compradores.precios = data.precios;

                    abonado = {
                        dia_abonado: 1,
                        datos_compradores: this.datos_compradores,
                        entradas: this.entradas,
                        asientos: this.asientos,
                        puede_cambiar: this.puede_cambiar
                    }
                } else {
                    abonado = {
                        dia_abonado: 0,
                        puede_cambiar: true
                    }
                }

                this.$emit('goTo', paso, data, abonado);
            },
            getZonas() {
                this.cargando = true;
                const params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    this.cargando = false;
                });
            },
            actualizar() {
                this.loading = true;

                var ok = false;
                for(var i in this.entradas) {
                    if(this.entradas[i].unidades > 0) {
                        ok = true;
                    }
                }

                if(ok) {
                    this.continuar = true;
                } else {
                    this.continuar = false;
                }
                this.loading = false;
            },
            seleccionarNuevoAsiento() {
                if(this.datos_compradores.asiento) {
                    this.datos_compradores.asiento = null;
                }
                
                this.$scrollTo('#mapa', 100);
            },
            contiuarConMiAsiento(cambiar) {
                var zona_seleccionada = null;

                for(var i in this.zonas) {
                    if(this.zonas[i].id == this.asientos[0].asiento.zona_id) {
                        zona_seleccionada = this.zonas[i];
                    }
                }

                this.$emit('goTo', 3, zona_seleccionada, {
                    dia_abonado: 1,
                    datos_compradores: this.datos_compradores,
                    entradas: this.entradas,
                    asientos: this.asientos,
                    puede_cambiar: cambiar
                });
            },
            buscarAbonado() {
                this.error = false;
                this.buscando = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.abonado_search.dni,
                        qr_code: this.abonado_search.qr_code,
                        n_abonado: this.abonado_search.n_abonado,
                        precio_reducido: true,
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id,
                        taquilla: true
                    },
                    tid: this.configuracion.hash_teatro,
                    dni: this.abonado_search.dni,
                    n_abonado: this.abonado_search.n_abonado,
                    precio_reducido: true,
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    taquilla: true

                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(res => {
                    this.buscando = false;
                    if(res.data.error) {
                        this.error = res.data.error;
                    } else {
                        if(res.data.comprado) {
                            this.error = 'comprado';
                        } else {
                            this.asientos.push({
                                'apellidos': res.data.info_abonado.apellidos,
                                'asiento': null,
                                'precio': null,
                                'dni': '',
                                'nombre': res.data.info_abonado.nombre,
                                'telefono': ''
                            });

                            if(res.data.asiento_disponible && res.data.precio_reducido.length > 0) {
                                this.asiento_disponible = true;

                                this.asientos[0].precio = {
                                    'descripcion': res.data.precio_reducido[0].descripcion,
                                    'gd': res.data.precio_reducido[0].price_management_online,
                                    'gd_interno': res.data.precio_reducido[0].price_management_online_interno,
                                    'id': res.data.precio_reducido[0].id,
                                    'precio': res.data.precio_reducido[0].precio,
                                    'precio_total': res.data.precio_reducido[0].precio_total,
                                    'price_management_taquilla': res.data.precio_reducido[0].price_management_taquilla
                                };

                                this.asientos[0].asiento = {
                                    'asiento': res.data.asiento.butaca,
                                    'event_ticket_id': res.data.precio_reducido[0].id,
                                    'fila': res.data.asiento.fila,
                                    'zona_id': res.data.asiento.zona_id,
                                    'zona_nombre': res.data.asiento.zona
                                };

                                this.datos_compradores.asiento = {
                                    'asiento': res.data.asiento.butaca,
                                    'event_ticket_id': res.data.precio_reducido[0].id,
                                    'fila': res.data.asiento.fila,
                                    'zona_id': res.data.asiento.zona_id,
                                    'zona_nombre': res.data.asiento.zona
                                };
                            }


                            this.datos_compradores.id = res.data.info_abonado.id;
                            this.datos_compradores.email = res.data.info_abonado.email;
                            this.datos_compradores.nombre = res.data.info_abonado.nombre;
                            this.datos_compradores.apellidos = res.data.info_abonado.apellidos;

                            if(res.data.precio_reducido.length > 0) {
                                this.datos_compradores.precios = [];

                                for (var i in res.data.precio_reducido) {
                                    this.datos_compradores.precios.push({
                                        'descripcion': res.data.precio_reducido[i].descripcion,
                                        'gd': res.data.precio_reducido[i].price_management_taquilla,
                                        'gd_interno': res.data.precio_reducido[i].price_management_taquilla_interno,
                                        'id': res.data.precio_reducido[i].id,
                                        'precio': res.data.precio_reducido[i].precio,
                                        'precio_total': res.data.precio_reducido[i].precio_total,
                                        'price_management_taquilla': res.data.precio_reducido[0].price_management_taquilla
                                    });
                                }
                            }

                            this.zona = {
                                'id': res.data.asiento.zona_id,
                                'name': res.data.asiento.zona
                            };



                            this.puede_cambiar = res.data.puede_cambiar_asiento;


                            //Si es el majadahonda no puede cambiar de asiento
                            if(this.configuracion.hash_teatro == 'xr6ASEHHSAjuAknejBfr') {
                                this.puede_cambiar = false;
                            }

                            if(!this.puede_cambiar && this.asiento_disponible) {
                                this.$nextTick(function() {
                                    var zona_seleccionada = null;

                                    for(var i in this.zonas) {
                                        if(this.zonas[i].id == res.data.asiento.zona_id) {
                                            zona_seleccionada = this.zonas[i];
                                        }
                                    }

                                    this.$emit('goTo', 3, zona_seleccionada, {
                                        dia_abonado: 1,
                                        datos_compradores: this.datos_compradores,
                                        entradas: this.entradas,
                                        asientos: this.asientos,
                                        puede_cambiar: false
                                    });
                                });
                            } else {
                                this.mostrar_opciones = true;
                            }

                        }
                    }

                    this.loading = false;
                }).catch(error => {
                    this.error = 'El abonado no existe';
                    this.buscando = false;
                    this.mostrar_opciones = false;
                });
            },
        },
        components: {
            MapaSvgComponent, TablaSectoresComponent, BuscarAbonadoComponent, CleSvgComponent
        }
    }
</script>

<style>

</style>
